<template>
  <div>
    <el-row :gutter="10">
      <!-- ==================== lista ==================== -->
      <el-col :xs="24" :sm="8">
        <c-panel title="Métricas cadastradas" titleIcon="fas fa-calculator">
          <el-button size="small" type="primary" icon="el-icon-plus" class="u-mb-10"
                     @click="nova" data-test="btn-nova">NOVA MÉTRICA</el-button>

          <div v-if="carregandoLista" class="estado" data-test="lista-carregando">
            <i class="el-icon-loading"></i> carregando…
          </div>
          <div v-else-if="erroLista" class="estado erro" data-test="lista-erro">{{ erroLista }}</div>
          <div v-else-if="!metricas.length" class="estado" data-test="lista-vazia">
            Nenhuma métrica cadastrada ainda.
          </div>
          <table v-else class="table table-striped" data-test="lista-metricas">
            <tr v-for="m in metricas" :key="m.chave" :class="{ ativa: m.chave === form.chave }">
              <td>
                <b>{{ m.rotulo }}</b>
                <el-tag v-if="m.sintetizada" size="mini" type="success" class="u-ml-5">sintetizada</el-tag>
                <div class="chave">{{ m.chave }} · v{{ m.versao }}</div>
              </td>
              <td style="width:120px">
                <el-button type="text" size="mini" @click="editar(m.chave)">editar</el-button>
                <el-button class="u-ml-10" type="text" size="mini" @click="avaliar(m.chave)">avaliar</el-button>
              </td>
            </tr>
          </table>
        </c-panel>
      </el-col>

      <!-- ==================== construtor ==================== -->
      <el-col :xs="24" :sm="16">
        <c-panel :title="form.chave ? 'Editando: ' + form.chave : 'Nova métrica'"
                 titleIcon="fas fa-sliders-h">
          <el-form label-position="top" size="small">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8">
                <el-form-item label="Chave (identificador)">
                  <el-input v-model="form.chave" :disabled="editando" placeholder="ex: indice_gestao"
                            data-test="campo-chave"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="10">
                <el-form-item label="Rótulo">
                  <el-input v-model="form.rotulo" data-test="campo-rotulo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="6">
                <el-form-item label="Unidade">
                  <el-input v-model="form.unidade" placeholder="pontos, %, un"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :xs="24" :sm="8">
                <el-form-item label="Agregação">
                  <el-select v-model="form.agregacao" style="width:100%" data-test="campo-agregacao">
                    <el-option v-for="a in agregacoes" :key="a" :label="a" :value="a"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="Normalização">
                  <el-select v-model="form.normalizacao" style="width:100%">
                    <el-option label="nenhuma" value="nenhuma"></el-option>
                    <el-option label="0 a 100" value="0-100"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="4">
                <el-form-item label="Faixa mín."><el-input v-model="form.faixa_min"></el-input></el-form-item>
              </el-col>
              <el-col :xs="24" :sm="4">
                <el-form-item label="Faixa máx."><el-input v-model="form.faixa_max"></el-input></el-form-item>
              </el-col>
            </el-row>

            <el-checkbox v-model="form.sintetizada" data-test="campo-sintetizada">
              É uma métrica sintetizada (agrega várias outras)
            </el-checkbox>
          </el-form>

          <!-- ==================== componentes ==================== -->
          <div class="secao">
            <div class="secao-titulo">
              Componentes
              <el-button type="text" size="mini" @click="adicionarComponente"
                         data-test="btn-add-componente">+ adicionar componente</el-button>
            </div>

            <div v-if="!form.componentes.length" class="estado">
              Nenhum componente. Uma métrica precisa de ao menos um.
            </div>

            <div v-for="(c, i) in form.componentes" :key="i" class="componente" data-test="componente">
              <el-row :gutter="8">
                <el-col :span="4">
                  <el-select v-model="c.tipo" size="mini" style="width:100%" @change="c.referencia = ''">
                    <el-option v-for="t in tipos" :key="t" :label="t" :value="t"></el-option>
                  </el-select>
                </el-col>

                <el-col :span="9">
                  <!-- referência muda conforme o tipo -->
                  <el-select v-if="c.tipo === 'metrica'" v-model="c.referencia" size="mini"
                             style="width:100%" placeholder="métrica">
                    <el-option v-for="m in metricasDisponiveis" :key="m.chave"
                               :label="m.rotulo" :value="m.chave"></el-option>
                  </el-select>
                  <el-input v-else-if="c.tipo === 'expressao'" v-model="c.expressao" size="mini"
                            placeholder="ex: 100 - taxa_evasao"></el-input>
                  <el-input v-else v-model="c.referencia" size="mini"
                            :placeholder="placeholderRef(c.tipo)"></el-input>
                </el-col>

                <el-col :span="3">
                  <el-input v-model="c.peso" size="mini" placeholder="peso"></el-input>
                </el-col>

                <el-col :span="5">
                  <el-input v-model="c.rotulo" size="mini" placeholder="rótulo"></el-input>
                </el-col>

                <el-col :span="3" style="text-align:right">
                  <el-button type="text" size="mini" @click="editarFiltro(i)">filtro</el-button>
                  <el-button class="u-ml-10" type="text" size="mini" @click="removerComponente(i)">remover</el-button>
                </el-col>
              </el-row>
              <div v-if="c.filtro && Object.keys(c.filtro).length" class="filtro-resumo">
                filtro: {{ resumoFiltro(c.filtro) }}
              </div>
            </div>

            <div class="soma-pesos" :class="{ ruim: form.agregacao === 'media_ponderada' && !pesosOk }">
              Soma dos pesos: {{ somaPesos.toFixed(4) }}
              <span v-if="form.agregacao === 'media_ponderada'">
                — {{ pesosOk ? 'ok' : 'a média ponderada exige soma 1' }}
              </span>
            </div>
          </div>

          <!-- ==================== validação e ações ==================== -->
          <el-alert v-if="erroValidacao" type="error" :closable="false" show-icon
                    class="u-mt-10" data-test="erro-validacao"
                    :title="erroValidacao"></el-alert>

          <el-alert v-if="validadaOk" type="success" :closable="false" show-icon
                    class="u-mt-10" title="Composição válida."></el-alert>

          <div class="u-mt-10">
            <el-button size="small" :loading="validando" @click="validar"
                       data-test="btn-validar">VALIDAR</el-button>
            <el-button class="u-ml-10" size="small" :loading="previewando" @click="preview"
                       data-test="btn-preview">PRÉ-VISUALIZAR</el-button>
            <el-button class="u-ml-10" size="small" type="primary" :loading="salvando" @click="salvar"
                       data-test="btn-salvar">SALVAR</el-button>
            <el-button class="u-ml-10" v-if="editando" size="small" @click="verVersoes">VERSÕES</el-button>
          </div>
        </c-panel>

        <!-- ==================== decomposição ==================== -->
        <c-panel v-if="resultado" title="Resultado e decomposição" titleIcon="fas fa-list-ol"
                 class="u-mt-10">
          <div class="resultado-valor" data-test="resultado-valor">
            {{ resultado.valor === null ? '—' : resultado.valor }}
            <small>{{ resultado.unidade }}</small>
            <el-tag size="mini" class="u-ml-5">versão {{ resultado.versao }}</el-tag>
            <el-tag size="mini" type="info" class="u-ml-5">{{ resultado.agregacao }}</el-tag>
          </div>

          <table class="table table-striped u-mt-10" data-test="tabela-decomposicao">
            <thead>
              <tr><th>Componente</th><th>Tipo</th><th>Bruto</th><th>Peso</th>
                  <th>Contribuição</th><th>Fonte</th></tr>
            </thead>
            <tbody>
              <tr v-for="(c, i) in resultado.componentes" :key="i">
                <td>{{ c.rotulo }}</td>
                <td>{{ c.tipo }}</td>
                <td>{{ c.valor_bruto === null ? '—' : c.valor_bruto }}</td>
                <td>{{ c.peso }}</td>
                <td>{{ c.contribuicao === null ? '—' : c.contribuicao }}</td>
                <td class="fonte">{{ c.fonte || '—' }}</td>
              </tr>
            </tbody>
          </table>

          <div class="fontes" v-if="resultado.fontes && resultado.fontes.length">
            Fontes que alimentaram este número: {{ resultado.fontes.join(' · ') }}
          </div>
        </c-panel>
      </el-col>
    </el-row>

    <!-- filtro de componente -->
    <el-dialog title="Filtro do componente" :visible.sync="dialogFiltro" width="420px" append-to-body>
      <p class="obs">Pares dimensão = valor. Restringem o fato lido por este componente.</p>
      <div v-for="(p, i) in filtroEdicao" :key="i" class="u-mb-5">
        <el-row :gutter="6">
          <el-col :span="10"><el-input v-model="p.chave" size="mini" placeholder="dimensão"></el-input></el-col>
          <el-col :span="10"><el-input v-model="p.valor" size="mini" placeholder="valor"></el-input></el-col>
          <el-col :span="4"><el-button type="text" size="mini" @click="filtroEdicao.splice(i,1)">x</el-button></el-col>
        </el-row>
      </div>
      <el-button type="text" size="mini" @click="filtroEdicao.push({chave:'',valor:''})">+ par</el-button>
      <span slot="footer">
        <el-button @click="dialogFiltro = false">CANCELAR</el-button>
        <el-button class="u-ml-10" type="primary" @click="aplicarFiltro">APLICAR</el-button>
      </span>
    </el-dialog>

    <!-- versões -->
    <el-dialog title="Histórico de versões" :visible.sync="dialogVersoes" width="480px" append-to-body>
      <table class="table table-striped">
        <tr><th>Versão</th><th>Componentes</th><th>Criada em</th><th></th></tr>
        <tr v-for="v in versoes" :key="v.versao">
          <td>{{ v.versao }}</td><td>{{ v.componentes }}</td><td>{{ v.criada_em }}</td>
          <td><el-button type="text" size="mini" @click="avaliarVersao(v.versao)">avaliar</el-button></td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
/**
 * FASE 5 / BLOCO BA-4 — BI 16 e 18.
 *
 * O CONSTRUTOR GENÉRICO, pela tela.
 *
 * O edital pede "cadastro de métricas sintetizadas": um mecanismo operado por interface, e
 * não um índice programado. Esta tela cria uma métrica INÉDITA sem nenhuma linha de código
 * dedicada a ela — componentes de tipos diferentes, pesos, filtros, normalização, validação,
 * pré-visualização, salvamento, versionamento e decomposição.
 *
 * A validação exibida aqui é ECO da validação do servidor. A soma de pesos aparece na tela
 * como conveniência de UX, mas quem recusa é o backend (`BiMetricaService::validar`) — se
 * fosse o contrário, bastaria o DevTools para gravar métrica inválida.
 */
import biApi from '../biApi'

export default {
  data () {
    return {
      api: null,
      metricas: [],
      carregandoLista: false,
      erroLista: null,
      editando: false,
      form: this.formVazio(),
      agregacoes: ['soma', 'media', 'media_ponderada', 'razao', 'diferenca',
                   'percentual', 'minimo', 'maximo'],
      tipos: ['fato', 'metrica', 'indicador', 'expressao', 'constante'],
      erroValidacao: null,
      validadaOk: false,
      resultado: null,
      versoes: [],
      validando: false,
      previewando: false,
      salvando: false,
      dialogFiltro: false,
      dialogVersoes: false,
      filtroEdicao: [],
      componenteEmFiltro: null
    }
  },

  computed: {
    somaPesos () {
      return this.form.componentes.reduce(function (s, c) {
        const p = parseFloat(c.peso)
        return s + (isNaN(p) ? 1 : p)
      }, 0)
    },
    pesosOk () { return Math.abs(this.somaPesos - 1) < 0.0001 },
    metricasDisponiveis () {
      const chave = this.form.chave
      // Não oferece a própria métrica como componente — o ciclo mais óbvio.
      return this.metricas.filter(function (m) { return m.chave !== chave })
    }
  },

  mounted () {
    this.api = biApi.criar({ axios: this.$axios, base: this.base(), auth: this.auth() })
    this.carregarLista()
  },

  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },

    formVazio () {
      return {
        chave: '', rotulo: '', unidade: '', agregacao: 'soma', normalizacao: 'nenhuma',
        faixa_min: '', faixa_max: '', sintetizada: false, componentes: []
      }
    },

    /**
     * Normaliza o erro que a API devolve.
     *
     * ARMADILHA REAL deste backend: negativa de permissão vem com HTTP **200** e corpo
     * `{erro: {cod: 800, text: '...'}}` — não com 403. Tratar só `status === 403` nunca
     * dispararia, e atribuir `d.erro` direto renderizaria "[object Object]" na tela.
     * O interceptor global de `main.js` já redireciona 800/801 para `/not-permission`;
     * isto cobre os demais casos e o texto exibido.
     */
    textoErro (erro) {
      if (!erro) return null
      if (typeof erro === 'string') return erro
      if (erro.text) return erro.text
      if (erro.message) return erro.message
      return 'Não foi possível concluir a operação.'
    },

    mensagemErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.status === 403) return 'Você não tem autorização para esta operação.'
      if (r.data && r.data.erro) return this.textoErro(r.data.erro)
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    carregarLista () {
      const self = this
      this.carregandoLista = true
      this.erroLista = null
      this.api.listarMetricas({}).then(function (r) {
        self.metricas = r.data || []
        self.carregandoLista = false
      }).catch(function (e) {
        self.carregandoLista = false
        self.erroLista = self.mensagemErro(e)
      })
    },

    nova () {
      this.form = this.formVazio()
      this.editando = false
      this.resultado = null
      this.erroValidacao = null
      this.validadaOk = false
    },

    editar (chave) {
      const self = this
      this.api.detalheMetrica(chave).then(function (r) {
        const d = r.data || {}
        if (d.erro) { self.erroValidacao = self.textoErro(d.erro); return }
        const m = d.metrica
        self.form = {
          chave: m.chave, rotulo: m.rotulo, unidade: m.unidade,
          agregacao: m.agregacao, normalizacao: m.normalizacao,
          faixa_min: m.faixa_min, faixa_max: m.faixa_max,
          sintetizada: !!m.sintetizada,
          componentes: (d.componentes || []).map(function (c) {
            return {
              tipo: c.tipo, referencia: c.referencia, peso: c.peso,
              rotulo: c.rotulo, expressao: c.expressao,
              filtro: c.filtro ? JSON.parse(c.filtro) : null
            }
          })
        }
        self.editando = true
        self.resultado = null
        self.erroValidacao = null
        self.validadaOk = false
      }).catch(function (e) {
        self.erroValidacao = self.mensagemErro(e)
      })
    },

    adicionarComponente () {
      this.form.componentes.push({ tipo: 'fato', referencia: '', peso: 1, rotulo: '', filtro: null })
      this.validadaOk = false
    },

    removerComponente (i) {
      this.form.componentes.splice(i, 1)
      this.validadaOk = false
    },

    placeholderRef (tipo) {
      if (tipo === 'fato') return 'dominio.metrica — ex: matricula.alunos_ativos'
      if (tipo === 'indicador') return 'ex: taxa_frequencia'
      if (tipo === 'constante') return 'valor numérico'
      return ''
    },

    editarFiltro (i) {
      this.componenteEmFiltro = i
      const f = this.form.componentes[i].filtro || {}
      this.filtroEdicao = Object.keys(f).map(function (k) { return { chave: k, valor: f[k] } })
      if (!this.filtroEdicao.length) this.filtroEdicao = [{ chave: '', valor: '' }]
      this.dialogFiltro = true
    },

    aplicarFiltro () {
      const f = {}
      this.filtroEdicao.forEach(function (p) {
        if (p.chave && p.valor !== '') f[p.chave] = p.valor
      })
      this.form.componentes[this.componenteEmFiltro].filtro = Object.keys(f).length ? f : null
      this.dialogFiltro = false
      this.validadaOk = false
    },

    resumoFiltro (f) {
      return Object.keys(f).map(function (k) { return k + '=' + f[k] }).join(', ')
    },

    /** Payload enviado ao backend — exposto para teste. */
    payload () {
      return {
        chave: this.form.chave,
        rotulo: this.form.rotulo,
        unidade: this.form.unidade,
        agregacao: this.form.agregacao,
        normalizacao: this.form.normalizacao,
        faixa_min: this.form.faixa_min === '' ? null : this.form.faixa_min,
        faixa_max: this.form.faixa_max === '' ? null : this.form.faixa_max,
        sintetizada: this.form.sintetizada,
        componentes: this.form.componentes.map(function (c) {
          return {
            tipo: c.tipo,
            referencia: c.tipo === 'expressao' ? null : c.referencia,
            expressao: c.tipo === 'expressao' ? c.expressao : null,
            peso: c.peso === '' || c.peso === null ? 1 : parseFloat(c.peso),
            rotulo: c.rotulo,
            filtro: c.filtro
          }
        })
      }
    },

    /** Quem decide se é válida é o SERVIDOR. */
    validar () {
      if (this.validando) return
      const self = this
      this.validando = true
      this.erroValidacao = null
      this.validadaOk = false

      this.api.validarMetrica(this.payload()).then(function (r) {
        self.validando = false
        if (r.data && r.data.valida) self.validadaOk = true
        else self.erroValidacao = (r.data && r.data.erro) || 'Composição inválida.'
      }).catch(function (e) {
        self.validando = false
        self.erroValidacao = self.mensagemErro(e)
      })
    },

    /**
     * Pré-visualização: salva nada. Avalia a métrica JÁ GRAVADA quando existe; para métrica
     * nova, valida e avisa que é preciso salvar antes — o cálculo é do servidor, e inventar
     * um cálculo local aqui criaria a segunda fonte de verdade que a spec proíbe.
     */
    preview () {
      if (this.previewando) return
      const self = this
      this.previewando = true
      this.erroValidacao = null

      this.api.validarMetrica(this.payload()).then(function (r) {
        if (!r.data || !r.data.valida) {
          self.previewando = false
          self.erroValidacao = (r.data && r.data.erro) || 'Composição inválida.'
          return
        }
        if (!self.editando) {
          self.previewando = false
          self.validadaOk = true
          window.eventBus.$emit('alert', {
            msg: 'Composição válida. Salve para calcular — o valor é sempre computado no servidor.',
            type: 'info'
          })
          return
        }
        self.api.avaliarMetrica(self.form.chave, {}).then(function (r2) {
          self.previewando = false
          if (r2.data && r2.data.erro) { self.erroValidacao = r2.data.erro; return }
          self.resultado = r2.data
        }).catch(function (e) {
          self.previewando = false
          self.erroValidacao = self.mensagemErro(e)
        })
      }).catch(function (e) {
        self.previewando = false
        self.erroValidacao = self.mensagemErro(e)
      })
    },

    salvar () {
      if (this.salvando) return             // duplo clique não cria duas versões
      const self = this
      this.salvando = true
      this.erroValidacao = null

      this.api.salvarMetrica(this.payload()).then(function (r) {
        self.salvando = false
        if (r.data && r.data.erro) { self.erroValidacao = r.data.erro; return }
        self.editando = true
        window.eventBus.$emit('alert', {
          msg: 'Métrica salva na versão ' + r.data.versao + '.', type: 'success'
        })
        self.carregarLista()
        self.avaliar(self.form.chave)
      }).catch(function (e) {
        self.salvando = false
        self.erroValidacao = self.mensagemErro(e)
      })
    },

    avaliar (chave) {
      const self = this
      this.api.avaliarMetrica(chave, {}).then(function (r) {
        if (r.data && r.data.erro) { self.erroValidacao = r.data.erro; self.resultado = null; return }
        self.resultado = r.data
      }).catch(function (e) {
        self.erroValidacao = self.mensagemErro(e)
      })
    },

    avaliarVersao (versao) {
      const self = this
      this.api.avaliarMetrica(this.form.chave, { versao: versao }).then(function (r) {
        self.resultado = r.data
        self.dialogVersoes = false
      })
    },

    verVersoes () {
      const self = this
      this.api.versoesMetrica(this.form.chave).then(function (r) {
        self.versoes = r.data || []
        self.dialogVersoes = true
      })
    }
  }
}
</script>

<style scoped>
.estado { padding: 16px; text-align: center; color: #909399; font-size: 12px; }
.estado.erro { color: #F56C6C; }
.chave { font-size: 11px; color: #909399; }
.ativa { background: #ecf5ff !important; }
.secao { margin-top: 14px; border-top: 1px solid #ebeef5; padding-top: 10px; }
.secao-titulo { font-weight: 600; font-size: 13px; margin-bottom: 8px; }
.componente { border: 1px solid #ebeef5; border-radius: 4px; padding: 6px; margin-bottom: 6px; }
.filtro-resumo { font-size: 11px; color: #909399; margin-top: 4px; }
.soma-pesos { font-size: 12px; color: #606266; margin-top: 6px; }
.soma-pesos.ruim { color: #E6A23C; font-weight: 600; }
.resultado-valor { font-size: 28px; font-weight: 600; }
.resultado-valor small { font-size: 13px; color: #909399; }
.fonte { font-size: 11px; color: #909399; }
.fontes { font-size: 11px; color: #909399; margin-top: 6px; }
.obs { font-size: 12px; color: #909399; }
</style>
